export enum CommonElementTabs {
  TESTIMONIALS = 'Testimonials',
  SCREENSHOT_REVIEWS = 'Screenshot Reviews',
}
